/**
 * native request 响应体类型
 */
export interface NativeResponse<T = unknown> {
  /** 业务状态码，200表示成功，非200表示失败 */
  code: number
  /** 响应数据 */
  data?: T
  /** 错误信息 */
  msg?: string
}

/**
 * native request 支持的请求方法枚举
 */
export const enum HttpMethod {
  GET = 'GET',
  POST = 'POST',
}

/**
 * native request 函数的参数类型
 */
export interface HttpRequestOptions {
  /** 请求路径，不包含域名，由原生拼接域名 */
  url: string
  method: HttpMethod
  data?: unknown
}
